import { useCallback, useState, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import { DialogCloseContext } from './dialog-close-context';
import { DialogCloseGuardModal } from './dialog-close-guard-modal';

type DialogCloseGuardProps = {
  onConfirmedClose: () => void;
  children: ReactNode;
};

export const DialogCloseGuard = ({
  onConfirmedClose,
  children,
}: DialogCloseGuardProps) => {
  const { formState } = useFormContext();
  const [showWarning, setShowWarning] = useState(false);

  const requestClose = useCallback(() => {
    if (formState.isDirty) {
      setShowWarning(true);
    } else {
      onConfirmedClose();
    }
  }, [formState.isDirty, onConfirmedClose]);

  const confirmDiscard = () => {
    setShowWarning(false);
    onConfirmedClose();
  };

  return (
    <DialogCloseContext.Provider value={requestClose}>
      {children}
      <DialogCloseGuardModal
        showWarning={showWarning}
        setShowWarning={setShowWarning}
        confirmDiscard={confirmDiscard}
      />
    </DialogCloseContext.Provider>
  );
};
